export default __webpack_public_path__ + "static/media/selectPlotter.708003df.png";